import { PluginFunction, PluginOptions } from './plugin';

const NormalizeErrorMessage: PluginFunction = ({ method, message }: PluginOptions) => {
  if (typeof message == 'object' && message.message instanceof Error) {
    const err = message.message as Error;
    message = {
      ...message,
      message: err.message,
      stack: err.stack,
      cause: err,
      // FIXME: cause is apparently es2022 :-|
      // cause: err.cause,
    };
  }

  return method(message);
};

export { NormalizeErrorMessage };
